import React, { Component } from 'react';
import Link from '@material-ui/core/Link';
import Dialog from 'material-ui/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import TextField from '@material-ui/core/TextField';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import CheckIcon from '@mui/icons-material/Check';
import Typography from '@material-ui/core/Typography';
import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

class UserInfoDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            jurisdictionalUnitValid: null,
            homeUnitId: null,
            jobTitle: null
        };
    }

    
    componentDidUpdate(prevProps, prevState) {
        if (!prevProps.userSession && this.props.userSession) {
            this.setState({
                protectingUnitValid: null,
                homeUnitId: this.props.userSession.HomeUnitId,
                jobTitle: this.props.userSession.JobTitle
            });

            this.onProtectingUnitChange(this.props.userSession.HomeUnitId);
        }
    }

    saveChanges = () => {
        const sessionClone = structuredClone(this.props.userSession);
        sessionClone.HomeUnitId = this.state.homeUnitId;
        sessionClone.JobTitle = this.state.jobTitle;

        this.props.onSave(sessionClone);
    }

    onTitleChange = (title) => {
        this.setState({
            jobTitle: title,
        });
    }

    onProtectingUnitChange = (unit) => {
        this.setState({
            homeUnitId: unit,
        });

        if (!unit || unit === null || unit === '') {
            this.setState({
                protectingUnitValid: null
            });
        }
        if (unit && unit !== null && unit !== '') {
            window.api.getUnitId(unit).then(unitIdResponse => {
                const protectingUnitIdIsValid = (unitIdResponse && unitIdResponse.units && unitIdResponse.units.length > 0);

                this.setState({
                    protectingUnitValid: protectingUnitIdIsValid
                });
            });
        }
    }

    render() {

        const showProtectingUnitIcon = this.state.protectingUnitValid !== null;
        const protectingIconToShow = (showProtectingUnitIcon) ? ((this.state.protectingUnitValid) ? (<CheckIcon color="success" />) : (<DoNotDisturbAltIcon color="error" />)) : '';

        return (!this.props.open) ? "" : (
            <Dialog
                modal={true}
                open={this.props.open}>
                <AppBar position="relative">
                    <Toolbar variant="dense">
                    <Typography variant="h6" color="inherit">
                        Update User Info
                    </Typography> 
                    <IconButton color="inherit" onClick={this.props.onClose} style={{ position: "relative", float: "right", marginLeft: "auto" }} aria-label="close">
                        <CloseIcon />
                    </IconButton>
                    </Toolbar>
                </AppBar>
                <p style={{ paddingLeft: "13px"}}>
                InFORM users are required to periodically update their information. <br/> <br/>
                Please ensure that your home unit and job title are provided.
                </p>
                <Table size="small">
                    <TableBody>
                        <TableRow>
                            <TableCell>First Name:</TableCell>
                            <TableCell align="right">{this.props.userSession.FirstName}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Last Name:</TableCell>
                            <TableCell align="right">{this.props.userSession.LastName}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Email:</TableCell>
                            <TableCell align="right">{this.props.userSession.Email}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={2} style={{ textAlign: 'left', fontSize: '0.8em', padding: '8px', fontWeight: 'bold' }}>
                                *Your name and email address are provided from your AGOL NIFC Org profile. If those are incorrect, please contact <Link href='mailto:wildfireresponse@firenet.gov' target="_blank">wildfireresponse@firenet.gov</Link> to update them.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Home Unit ID:<br/>(e.g. IDBOF or IDBDC)<br/>
                                <Link href='https://unitid.nifc.gov/ords/prd/f?p=116:10:2843014920846:::RP,10::' target="_blank">UnitID lookup</Link>
                        </TableCell>
                            <TableCell align="right" valign='top'>
                                <TextField
                                    style={{ width: "80px" }}
                                    inputProps={{ style: { textTransform: "uppercase" } }}
                                    value={this.state.homeUnitId}
                                    onChange={(e) => this.onProtectingUnitChange(e.target.value)}
                                />
                                {protectingIconToShow}
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell>Job Title:</TableCell>
                            <TableCell align="right">

                                <TextField
                                    name='jobTitleTxt'
                                    style={{ width: "300px" }}
                                    defaultValue={this.state.jobTitle}
                                    onChange={(event, value) => {
                                        this.setState({
                                            jobTitle: value
                                          });

                                          this.onTitleChange(event.target.value);
                                    }} />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
                <DialogActions>
                    <Button disabled={(!this.state.jobTitle || !this.state.homeUnitId) || (this.state.jobTitle === "" || this.state.homeUnitId === "")} onClick={ (e) => this.saveChanges() } color="primary">
                        Save
                    </Button>
                    <Button onClick={this.props.onClose}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default UserInfoDialog;
